import * as React from 'react';

interface Props {
    value: string;
    change: (value: string) => void;
    focus?: () => void;
    blur?: () => void;
    element?: (element: HTMLInputElement) => void;
}

const closeSearchEvent = new Event('closeSearchField');

export function SearchField({ element, value, change, focus, blur }: Props) {
    const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        if (e.target.value.length === 0) {
            window.dispatchEvent(closeSearchEvent);
        }
        if (blur) {
            blur();
        }
    };
    return (
        <div className='search-field'>
            <svg width="26" height="27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity=".7" d="M25.821 24.487l-6.55-6.55a.602.602 0 00-.432-.178c-.2 0-.306-.24-.178-.393a10.507 10.507 0 002.463-6.772c0-5.835-4.727-10.562-10.562-10.562C4.728.032 0 4.759 0 10.594c0 5.834 4.728 10.562 10.562 10.562 2.581 0 4.941-.928 6.776-2.461.151-.127.389-.022.389.176 0 .162.066.315.178.431l6.55 6.551a.61.61 0 00.863 0l.503-.503a.61.61 0 000-.863zm-15.259-4.956a8.93 8.93 0 01-8.937-8.937 8.93 8.93 0 018.937-8.937 8.93 8.93 0 018.937 8.937 8.93 8.93 0 01-8.937 8.937z" fill="#000" />
            </svg>
            <input
                type='text'
                placeholder='Sök här'
                ref={element}
                value={value}
                onFocus={() => focus?.()}
                onClick={() => focus?.()}
                onBlur={onBlur}
                onChange={e => change(e.target.value)} />
            <div className='bl-icon-close close-icon-black-24'></div>
        </div>
    );
}
